import { render, staticRenderFns } from "./MobileMenuProfile.vue?vue&type=template&id=fb4b4fac&scoped=true&"
import script from "./MobileMenuProfile.vue?vue&type=script&lang=js&"
export * from "./MobileMenuProfile.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuProfile.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./MobileMenuProfile.vue?vue&type=style&index=1&id=fb4b4fac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4b4fac",
  null
  
)

export default component.exports